export { default } from './FormPageAccount.vue'
